import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';
import app = firebase.app;

const firebaseConfig = {
    apiKey: "AIzaSyBsgs-qJNxkGdJ5lDSOZctHci8nVR2-VLg",
    authDomain: "tales-montagnana-site.firebaseapp.com",
    projectId: "tales-montagnana-site",
    storageBucket: "tales-montagnana-site.appspot.com",
    messagingSenderId: "841356279567",
    appId: "1:841356279567:web:851ee577bbac102ff4087a"
};

//initialize firebase
firebase.initializeApp(firebaseConfig);

//initialize.services
const db = firebase.firestore();
const storage = firebase.storage();

const auth = firebase.auth();

export {
    db,
    storage,
    auth,
}